import RequiredContextValue from "%/dynamic-component-editor/classes/required-context-value";

export function sourceNameRemaps(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return {};
  }

  const normalized = {};
  Object.entries(raw).forEach(([requiredName, sourceName]) => {
    if (typeof requiredName !== "string" || !requiredName) {
      return;
    }
    if (typeof sourceName !== "string" || !sourceName) {
      return;
    }
    normalized[requiredName] = sourceName;
  });

  return normalized;
}

// Every binding an embed supplies: name remaps plus value and entity objects.
// sourceNameRemaps keeps remaps only; never use it to decide "is it bound".
export function readInstanceContextBindings(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return {};
  }

  const bindings = {};
  Object.entries(raw).forEach(([requiredName, binding]) => {
    if (!requiredName) {
      return;
    }
    const isRemap = typeof binding === "string" && binding !== "";
    if (isRemap || RequiredContextValue.isPrimitiveBinding(binding) || RequiredContextValue.isEntityBinding(binding)) {
      bindings[requiredName] = binding;
    }
  });

  return bindings;
}

// Names bound to an entity (remap or entity object); value bindings are not entities.
export function requiredContextNames(bindings) {
  return Object.entries(readInstanceContextBindings(bindings))
      .filter(([, binding]) => !RequiredContextValue.isPrimitiveBinding(binding))
      .map(([name]) => name);
}

export function remapEntityBag(bag, bindings) {
  const source = bag && typeof bag === "object" ? bag : {};
  const remapped = { ...source };

  Object.entries(sourceNameRemaps(bindings)).forEach(([requiredName, sourceName]) => {
    if (source[sourceName] !== undefined) {
      remapped[requiredName] = source[sourceName];
    }
  });

  return remapped;
}
